//format date to readable string
export const formatDate = (date) => {
  var formatDate = new Date(date);
  var stringDate = formatDate.toDateString().split(" ");
  return stringDate[1] + " " + stringDate[2] + ", " + stringDate[3];
};
